


































import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { BAlert } from 'bootstrap-vue';
import GenericCard from '@/components/cards/GenericCard.vue';
import LoadingState from '@/components/cards/loading_state/LoadingState.vue';
import { Alert } from '@/components/global_alerts/types';
import { ModalSize } from '@/components/zen_modal/types';
import RiskCardText from './components/RiskCardText.vue';
import RiskCardNumber from './components/RiskCardNumber.vue';
import RiskAddOrRemoveItems from '@/components/cards/risk_settings/components/RiskAddOrRemoveItems.vue';
import { validate } from './RiskCardValidations';
import RiskCalculationBuilder from '@/components/cards/risk_settings/RiskCalculationBuilder/RiskCalculationBuilder.vue';
import { RiskCardType, RiskCardComponentType, RiskCardTypes, RiskAddOrRemoveItemsType } from './types';

export default Vue.extend({
  name: 'RiskEditCard',
  components: {
    BAlert,
    GenericCard,
    LoadingState,
    RiskCardText,
    RiskCardNumber,
    RiskAddOrRemoveItems,
    RiskCalculationBuilder,
  },
  props: {
    url: {
      type: String,
      required: false,
      default: '',
    },
    saveUrl: {
      type: String,
      required: false,
      default: '',
    },
    fieldName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    fieldType: {
      type: String,
      default: RiskCardType.Text,
      validator: prop => RiskCardTypes.includes(prop),
    },
    labels: {
      type: Array as PropType<Array<string>>,
      required: true,
      validator: prop => prop.length > 0 && prop.length <= 2,
    },
    required: {
      type: Boolean,
      default: false,
    },
    successMessage: {
      type: String,
      required: true,
    },
    addOrRemoveItemsType: {
      type: String as () => RiskAddOrRemoveItemsType,
      default: RiskAddOrRemoveItemsType.FactorOptions,
    },
    modalSize: {
      type: String,
      default: 'Small',
    },
  },
  data() {
    return {
      loading: <boolean>false,
      saving: <boolean>false,
      alerts: <Alert[]>[],
      value: <any>null,
      data: <any>{},
    };
  },
  computed: {
    ...mapGetters(['csrfToken']),
  },
  async created() {
    this.changeModalSize(ModalSize[this.modalSize]);
    if (this.url) {
      this.loading = true;
      try {
        this.data = await this.request({
          url: this.url,
          defaultErrorHandler: false,
        });
        this.value = this.data[this.fieldName];
      } catch (errors) {
        this.alerts = [errors.response.data];
      } finally {
        this.loading = false;
      }
    }
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      cancelModal: 'modals/cancel',
      confirmModal: 'modals/confirm',
      showAlert: 'alerts/show',
      request: 'request',
    }),
    getComponent() {
      return RiskCardComponentType[this.fieldType];
    },
    async save() {
      if (!this.isValid()) {
        return;
      }
      this.saving = true;
      try {
        await this.request({
          method: 'put',
          url: this.saveUrl ? this.saveUrl : this.url,
          data: {
            [this.fieldName]: this.value,
          },
          defaultErrorHandler: false,
        });
        this.showAlert({
          type: 'success',
          message: this.successMessage,
        });
        this.confirmModal();
      } catch (errors) {
        this.alerts = [errors.response.data];
      } finally {
        this.saving = false;
      }
    },
    isValid(): boolean {
      let errors: Alert[] = [];
      if (this.required) {
        errors = validate(this.fieldType, this.value, this.labels);
        this.alerts = errors;
      }
      return !errors.length;
    },
  },
});
